import analytics from 'libs/public-analytics';

window.analytics = analytics;
